import React from "react"
import { Navigate, useParams } from "react-router-dom"

const RedirectToReservations: React.FC = () => {
  const { slug } = useParams()

  return <Navigate to={`/panel/${slug}/reservations`} replace />
}

export default RedirectToReservations
